/*
 * File: /src/router/routes/guidbooks.js
 * Created Date: Saturday January 11th 2025
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 11th January 2025 7:18:52 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2025 AdBase, Inc.
 */

const GuidebookList = () =>
  import(
    /* webpackChunkName: "Guidebooks" */ 'src/components/Dashboard/Views/Guidebooks/GuidebookList.vue'
  );
const GuidebookBlockList = () =>
  import(
    /* webpackChunkName: "Guidebooks" */ 'src/components/Dashboard/Views/Guidebooks/GuidebookBlockList.vue'
  );
const GuidebookEdit = () =>
  import(
    /* webpackChunkName: "Guidebooks" */ 'src/components/Dashboard/Views/Guidebooks/GuidebookEdit.vue'
  );
const GuidebookBlockEdit = () =>
  import(
    /* webpackChunkName: "Guidebooks" */ 'src/components/Dashboard/Views/Guidebooks/GuidebookBlockEdit.vue'
  );

export const guidebookRoutes = [
  {
    path: 'guidebook-block/edit/:id',
    name: 'Guidebook Block Edit',
    component: GuidebookBlockEdit,
    props: (route) => ({
      id: parseInt(route.params.id),
    }),
  },

  {
    path: 'guidebook-block/add',
    name: 'Guidebook Block Add',
    component: GuidebookBlockEdit,
  },
  {
    path: 'guidebook-block/list',
    name: 'Guidebook Block List',
    component: GuidebookBlockList,
  },
  {
    path: 'guidebooks/edit/:id',
    name: 'Guidebook Edit',
    component: GuidebookEdit,
    props: (route) => ({
      id: parseInt(route.params.id),
    }),
  },
  {
    path: 'guidebooks/list',
    name: 'Guidebook List',
    component: GuidebookList,
  },
  {
    path: 'guidebooks/add',
    name: 'Guidebook Add',
    component: GuidebookEdit,
    props: (route) => ({
      id: undefined,
    }),
  },
];
